module.exports = __webpack_public_path__ + "3f00fb7fc8272d8df9570a93f5975cac.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/images/browser_opera.png
// module id = 369
// module chunks = 1